import React, {useEffect, useState} from 'react'
import axios from 'axios'

import {EditorState} from 'draft-js'
import {stateFromHTML} from 'draft-js-import-html'
import {Editor} from 'react-draft-wysiwyg'
import {convertToHTML} from 'draft-convert'

import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {BalconyBanner} from '../../components/Balcony/BalconyBanner'
import {ServiciosBalcony} from '../../components/Balcony/ServiciosBalcony'

function Balcony() {
  const url = 'https://puntosurgdl.com/backend/'

  const [textSection, setTextSection] = useState('')
  const [editorRawHtml, setEditorRawHtml] = useState('hola')

  const [editorState, setEditorState] = useState(() =>
    EditorState.createWithContent(stateFromHTML(editorRawHtml))
  )
  const [convertedContent, setConvertedContent] = useState(null)

  ///
  const [servicios, setServicios] = useState('')
  const [contactoTelefono, setContactoTelefono] = useState('')
  const [contactoCorreo, setContactoCorreo] = useState('')

  useEffect(() => {
    let html = convertToHTML(editorState.getCurrentContent())
    setConvertedContent(html)
  }, [editorState])

  useEffect(() => {
    getTextSection()
    getServiciosBalcony()
    getBalconyContactInformation()
    // setEditorOneRawHtml()
  }, [editorRawHtml])

  const getTextSection = () => {
    axios
      .get(url + 'getBalconyTextSection.php')
      .then((response) => {
        console.log(response.data.data[0].description)
        setEditorRawHtml(response.data.data[0].description)
        setEditorState(() => EditorState.createWithContent(stateFromHTML(editorRawHtml)))
        setTextSection(response.data.data[0])
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getBalconyContactInformation = () => {
    axios
      .get(url + 'getBalconyContactInformation.php')
      .then((response) => {
        console.log(response.data.data)
        const balconyContactInformation = response.data.data
        for (let key in balconyContactInformation) {
          switch (balconyContactInformation[key].idElement) {
            case 'balcony-contacto-telefono':
              setContactoTelefono(balconyContactInformation[key].description)
              break

            case 'balcony-contacto-correo':
              setContactoCorreo(balconyContactInformation[key].description)
              break

            default:
              break
          }
        }
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const saveTextSectionOne = () => {
    convertToHTML(editorState.getCurrentContent())

    const dataForm = new FormData()

    dataForm.append('name', 'balcony-text-section')
    dataForm.append('title', document.getElementById('balcony-text-section-title').value)
    dataForm.append('description', convertedContent)
    // const dataForm = {
    //   name: 'balcony-text-section',
    //   title: document.getElementById('balcony-text-section-title').value,
    //   description: convertedContentOne,
    // }
    if (document.getElementById('balcony-text-section-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('balcony-text-section-img').files.length; i++) {
        dataForm.append('file[]', document.getElementById('balcony-text-section-img').files[i])
      }
    }

    axios
      .post(url + 'saveBalconyTextSection.php', dataForm, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          document.getElementsByName('balcony-text-section-img')[0].value = null
          console.log(res)
        },
        (error) => {
          alert(error)
        }
      )
  }

  const saveContactInformation = () => {
    const dataForm = {
      namePhone: 'balcony-contacto-telefono',
      descriptionPhone: document.getElementById('balcony-contacto-telefono').value,
      nameMail: 'balcony-contacto-correo',
      descriptionMail: document.getElementById('balcony-contacto-correo').value,
    }

    // dataForm.append('namePhone', 'balcony-contacto-telefono')
    // dataForm.append('descriptionPhone', document.getElementById('balcony-contacto-telefono').value)

    // dataForm.append('nameMail', 'balcony-contacto-correo')
    // dataForm.append('descriptionMail', document.getElementById('balcony-contacto-correo').value)
    // const dataForm = {
    //   name: 'balcony-text-section',
    //   title: document.getElementById('balcony-text-section-title').value,
    //   description: convertedContentOne,
    // }
    // if (document.getElementById('balcony-text-section-img').files.length !== 0) {
    //   for (let i = 0; i < document.getElementById('balcony-text-section-img').files.length; i++) {
    //     dataForm.append('file[]', document.getElementById('balcony-text-section-img').files[i])
    //   }
    // }

    axios
      .post(url + 'saveContactoInformation.php', dataForm, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          // document.getElementsByName('balcony-text-section-img')[0].value = null
          console.log(res)
        },
        (error) => {
          alert(error)
        }
      )
  }

  const getServiciosBalcony = () => {
    axios
      .get(url + 'getServiciosBalcony.php')
      .then((response) => {
        let servicios = response.data.data
        console.log(servicios)
        setServicios(servicios)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  return (
    <div className='row g-5'>
      <BalconyBanner />

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Sección texto</h3>
            <h5 className='card-subtitle'>
              La imagen debe tener un formato vertical, con una medida mínima de 550px por 600px y
              no pesar más de 1MB
            </h5>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Titulo:</label>
                <input
                  type='text'
                  className='form-control'
                  id='balcony-text-section-title'
                  defaultValue={textSection.title}
                />
              </div>
            </div>
            <div className='form-group col-md-12 mb-20'>
              <label>Contenido:</label>
              <Editor
                editorState={editorState}
                toolbarClassName='toolbarClassName'
                wrapperClassName='wrapperClassName'
                onEditorStateChange={setEditorState}
              />
            </div>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Imagen:</label>
                <input
                  type='file'
                  className='form-control'
                  id='balcony-text-section-img'
                  name='balcony-text-section-img'
                />
              </div>
            </div>
          </div>
          <div className='card-footer'>
            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary mt-6'
                onClick={() => saveTextSectionOne()}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Servicios Balcony</h3>
            <h5 className='card-subtitle'>
              La imagen de los bloques alargados debe tener un formato horizontal, con una medida
              mínima de 1500px de ancho y no pesar más de 1MB
              <br /> La imagen de los bloques cuadradados debe tener un formato horizontal pero
              mucho menos ancho. Medida mimina de 1000px y no pesar más de 1MB
            </h5>
          </div>
          <div className='card-body'>
            <div className='row'>
              <ServiciosBalcony servicios={servicios} />
            </div>
          </div>
          {/* <div className='card-footer'>
            <div className='form-check form-switch form-check-custom form-check-solid mt-8'>
              <input className='form-check-input desc-active' type='checkbox' id='desc-active' />
              <label className='form-check-label' for='desc-active'>
                Activar modo imagen
              </label>
            </div>
            <div className='form-group float-end'>
              <button type='submit' className='btn btn-primary mt-6'>
                Guardar
              </button>
            </div>
          </div> */}
        </div>
      </div>

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Información de contacto formulario</h3>
          </div>
          <div className='card-body'>
            <h2>Información de contacto</h2>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Teléfono:</label>
                <input
                  type='text'
                  className='form-control'
                  id='balcony-contacto-telefono'
                  defaultValue={contactoTelefono}
                />
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Correo:</label>
                <input
                  type='text'
                  className='form-control'
                  id='balcony-contacto-correo'
                  defaultValue={contactoCorreo}
                />
              </div>
              <div className='col-md-2 mt-6 float-right'>
                <button
                  type='button'
                  className='btn btn-primary float-right'
                  onClick={() => saveContactInformation()}
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
          {/* <div className='card-footer'>
            <div className='form-check form-switch form-check-custom form-check-solid'>
              <input className='form-check-input' type='checkbox' value='' id='column-active' />
              <label className='form-check-label' for='column-active'>
                Habilitar columna única
              </label>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export {Balcony}
